<script>
    import {Bar, mixins} from 'vue-chartjs';

    export default {
        name   : "StatVisitsChart",
        extends: Bar,
        mixins : [mixins.reactiveProp],
        props  : {
            chartData: {
                type   : Object,
                default: null
            },
            options  : {
                type   : Object,
                default: null
            },
            interval : {
                type   : String,
                default: null
            }
        },
        mounted() {

            this.renderChart(
                this.chartData,
                {
                    responsive         : true,
                    maintainAspectRatio: false,
                    legend             : {
                        display: false,
                    },
                    scales             : {
                        xAxes: [{
                            type        : 'time',
                            distribution: 'series',
                            offset      : true,
                            ticks       : {
                                autoSkip: true,
                                source  : 'data',
                            },
                            time        : this.getxAxesTimeOptions(),
                            gridLines   : {
                                // display: false
                            }
                        }],
                        yAxes: [{
                            stacked  : true,
                            ticks    : {
                                autoSkip     : true,
                                maxTicksLimit: 1,
                                min          : 0,
                            },
                            gridLines: {
                                display: false
                            }
                        }]
                    },
                    tooltips           : {
                        position: 'nearest',
                    },
                }
            );
        },
        methods: {
            getxAxesTimeOptions() {
                switch (this.interval) {
                    case 'hour':
                        return {
                            minUnit       : 'hour',
                            displayFormats: {
                                hour: 'H:mm',
                            },
                            tooltipFormat : 'D MMM YYYY HH:mm',
                        };
                    case 'day' :
                        return {
                            unit         : 'day',
                            tooltipFormat: 'MMM D, YYYY',
                        };
                    case 'month':
                        return {
                            unit         : 'month',
                            tooltipFormat: 'MMM YYYY',
                        };
                }
            }
        }
    }
</script>

<style scoped>

</style>
